module.exports = __webpack_public_path__ + "static/img/LASHIC_healthlab_logo.618e297.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top/LASHIC_healthlab_logo.png
// module id = aw40
// module chunks = 1